// import Vue from "vue";
import axios from "axios";
import Store from "../store/index";
import auth from "../app/auth";

const baseURL = Store.state.apiURL;

export default {
  async get(url) {
    Store.state.loader = true
    var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          Store.state.cognitoInfo.companyid == undefined ||
            Store.state.cognitoInfo.companyid == null ||
            Store.state.cognitoInfo.companyid == "undefined" ||
            Store.state.cognitoInfo.companyid == "null"
            ? ""
            : Store.state.cognitoInfo.companyid,
        crossDomain: true
      },
    };
    return await axios
      .get(baseURL + url, jwtHeader)
      .then((res) => {
        Store.state.loader = false
        return res.data;
      })
      .catch((error) => {
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        this.$toast.add({
          severity: "danger",
          summary: "Error",
          detail: "Error|Something went wrong! Please try after sometime",
          life: 3000,
        });
        Store.state.loader = false
        return error;
      });
  }, 


  async getById(url, id, param = null, param1 = null, showLoader = true) {
    if (showLoader) Store.state.loader = true
    var getURL = baseURL + url + "/" + id;
    if (param != null) {
      getURL += "/" + param;
    }
    if (param1 != null && param1!="export") {
      getURL += "/" + param1;
    }
    var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          Store.state.cognitoInfo.companyid == undefined ||
            Store.state.cognitoInfo.companyid == null ||
            Store.state.cognitoInfo.companyid == "undefined" ||
            Store.state.cognitoInfo.companyid == "null"
            ? ""
            : Store.state.cognitoInfo.companyid,
        crossDomain: true,
        'content-type': 'application/x-www-form-urlencoded'
      },
    };
    return await axios
      .get(getURL, jwtHeader)
      .then((res) => {
        if (showLoader) Store.state.loader = false
        return res.data;
      })
      .catch((error) => {
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        this.$toast.add({
          severity: "danger",
          summary: "Error",
          detail: "Error|Something went wrong! Please try after sometime",
          life: 3000,
        });
        if (showLoader) Store.state.loader = false
        return error;
      });
  },
  async post(url, model, loader = true) {
    if (loader)
    Store.state.loader = true
    var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          Store.state.cognitoInfo.companyid == undefined ||
            Store.state.cognitoInfo.companyid == null ||
            Store.state.cognitoInfo.companyid == "undefined" ||
            Store.state.cognitoInfo.companyid == "null"
            ? ""
            : Store.state.cognitoInfo.companyid,
        crossDomain: true,
        timeout: 200000
      },
    };
    return await axios
      .post(baseURL + url, model, jwtHeader)
      .then((res) => {
        if (loader)
        Store.state.loader = false
        return res.data;
      })
      .catch((error) => {
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        // this.$toast.add({
        //   severity: "danger",
        //   summary: "Error",
        //   detail: "Error|Something went wrong! Please try after sometime",
        //   life: 3000,
        // });
        if (loader)
        Store.state.loader = false
        return error;
      }).finally(() => {
        Store.state.loader = false
    });
  },
  async delete(url, id, param = null) {
    Store.state.loader = true
    var deleteURL = baseURL + url + "/" + id;
    if (param != null) {
      deleteURL += "/" + param;
    }
    var accessToken = auth.auth.signInUserSession.idToken.jwtToken;
    var jwtHeader = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        CompanyId:
          Store.state.cognitoInfo.companyid == undefined ||
            Store.state.cognitoInfo.companyid == null ||
            Store.state.cognitoInfo.companyid == "undefined" ||
            Store.state.cognitoInfo.companyid == "null"
            ? ""
            : Store.state.cognitoInfo.companyid,
        crossDomain: true
      },
    };
    return await axios
      .delete(deleteURL, jwtHeader)
      .then((res) => {
        Store.state.loader = false
        return res.data;
      })
      .catch((error) => {
        // Vue.prototype.$alert(
        //   "Error|Something went wrong! Please try after sometime."
        // );
        this.$toast.add({
          severity: "danger",
          summary: "Error",
          detail: "Error|Something went wrong! Please try after sometime",
          life: 3000,
        });
        Store.state.loader = false
        return error;
      });
  },
};
